import type { ComponentType } from 'react';
import type { ReactGadgetProps } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { CustomReportGadgetData } from '../../common/types.tsx';

export const LazyCustomReportGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<CustomReportGadgetData>>
>(() => import(/* webpackChunkName: "async-react-custom-report-gadget-edit" */ './main'));
